module.exports = __webpack_public_path__ + "static/img/icon-part2-4.af42872.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icon-part2-4.png
// module id = vPY3
// module chunks = 1